<div class="main-container">
	<h3>
		<span [style.padding-left.px]="hasJobShifts ? 92 : 40">My work</span>
		
		<button mat-icon-button (click)="toggleShowAllShifts()" *ngIf="hasJobShifts"
			class="show-shifts-button">
			<div class="show-shifts-text">
				<span *ngIf="!isShowingAllShifts">My <br /> Shift</span>
				<span *ngIf="isShowingAllShifts">All <br /> Shifts</span>
			</div>
			<div class="show-shifts-icon">
				<mat-icon *ngIf="!isShowingAllShifts">watch_later</mat-icon>
				<mat-icon *ngIf="isShowingAllShifts">schedule</mat-icon>
			</div>
		</button>

		<button mat-icon-button (click)="filtersFormModel.patchValue(backupFilters); filtersModal.open()"
			[class.highlighted]="isFilterApplied">
			<mat-icon>filter_list</mat-icon>
		</button>
	</h3>
	<h5 class="account-name">
		{{userAccountInfoModel.accountName}}
	</h5>


	<mat-tab-group mat-align-tabs="center" [selectedIndex]="selectedCategoryIndex == null ? 0 : selectedCategoryIndex"
		class="categories-container" [class.hide-category-border]="selectedCategoryIndex === ViewCategory.ScheduledWork"
		(selectedIndexChange)="saveCategoryChange($event)">

		<mat-tab label="Scheduled Work">
			<ng-container *ngIf="selectedCategoryIndex === ViewCategory.ScheduledWork">
				<mat-tab-group mat-align-tabs="center" [selectedIndex]="selectedViewIndex" #scheduledMatTabGroup
					(selectedIndexChange)="saveTabChange($event)">
					<mat-tab label="By Project">
						<ng-container *ngIf="jobs.length && !isDataLoading">
							<ng-container
								*ngTemplateOutlet="scheduledJobList; context: { collection: jobsByProject, keys: jobsByProjectNameKeys }">
							</ng-container>
						</ng-container>
						<app-loader [isInline]="true" *ngIf="!jobs.length && isDataLoading"></app-loader>
						<p class="empty-message-container" *ngIf="!jobs.length && !isDataLoading">There are no jobs</p>
					</mat-tab>

					<mat-tab label="By Site">
						<ng-container *ngIf="jobs.length && !isDataLoading">
							<ng-container
								*ngTemplateOutlet="scheduledJobList; context: { collection: jobsBySite, keys: jobsBySiteNameKeys }">
							</ng-container>
						</ng-container>
						<app-loader [isInline]="true" *ngIf="!jobs.length && isDataLoading"></app-loader>
						<p class="empty-message-container" *ngIf="!jobs.length && !isDataLoading">There are no jobs</p>
					</mat-tab>

					<mat-tab label="By Day of Week">
						<ng-container *ngIf="jobs.length && !isDataLoading">
							<ng-container
								*ngTemplateOutlet="scheduledJobList; context: { collection: jobsByDayOfWeek, keys: jobsByDayOfWeekNameKeys }">
							</ng-container>
						</ng-container>
						<app-loader [isInline]="true" *ngIf="!jobs.length && isDataLoading"></app-loader>
						<p class="empty-message-container" *ngIf="!jobs.length && !isDataLoading">There are no jobs</p>
					</mat-tab>

					<!-- <mat-tab label="By Date">
						<ng-container *ngTemplateOutlet="jobList; context: { collection: jobsByDate, keys: jobsByDateKeys }">
						</ng-container>
					</mat-tab> -->
				</mat-tab-group>
			</ng-container>

		</mat-tab>

		<mat-tab label="Digital Logbook">
			<ng-container *ngIf="jobs.length && !isDataLoading">
				<ng-container
					*ngTemplateOutlet="digitalLogbookList; context: { collection: jobsInDigitalLogbooks, keys: jobInDigitalLogbooksNameKeys }">
				</ng-container>
			</ng-container>

			<p class="empty-message-container" *ngIf="!jobs.length && !isDataLoading">There are no jobs</p>
			<app-loader [isInline]="true" *ngIf="!jobs.length && isDataLoading"></app-loader>
		</mat-tab>

		<mat-tab label="Smart Docs">
			<ng-container *ngIf="jobs.length && !isDataLoading">
				<ng-container
					*ngTemplateOutlet="smartDocumentsList; context: { collection: jobsInSmartDocs, keys: jobsInSmartDocsKeys }">
				</ng-container>
			</ng-container>
			<p class="empty-message-container" *ngIf="!jobs.length && !isDataLoading">There are no jobs</p>
			<app-loader [isInline]="true" *ngIf="!jobs.length && isDataLoading"></app-loader>
		</mat-tab>
	</mat-tab-group>
</div>

<ng-template #scheduledJobList let-collection="collection" let-keys="keys">
	<p class="empty-message-container" *ngIf="!collectionHasValues(collection)">No jobs with current filter</p>
	<ng-container *ngFor="let key of keys">
		<details *ngIf="collection && collection.get && collection.get(key)">
			<summary>{{ collection.get(key).name }} ({{ collection.get(key).jobs.length }})</summary>

			<div class="job-container" *ngFor="let job of collection.get(key).jobs">
				<a mat-flat-button [href]="job.urlHash"
					[class.gray-text]="job.assignmentType !== null && job.assignmentType == AssignmentType.NotAssignedToYou">
					<p class="job-name-container">
						<span>{{ job.jobName }}</span>
						<mat-icon *ngIf="job.hasForms">description</mat-icon>
					</p>
					<span>{{ job.projectName }}</span>					
					<span *ngIf="job.siteAddress">{{ job.siteAddress }}</span>
					<span class="job-asset" *ngIf="job.asset">{{ job.asset }}</span>
					<span *ngIf="job.assignmentType !== null">{{ assignmentTypeLabel(job.assignmentType) }}</span>
					<span *ngIf="job.jobDate">ETA: {{ moment.parseZone(job.jobDate).format('dddd, MM/DD/YYYY')
						}}</span>
				</a>
			</div>
		</details>
	</ng-container>
</ng-template>

<ng-template #digitalLogbookList let-collection="collection" let-keys="keys">
	<p class="empty-message-container" *ngIf="!collectionHasValues(collection)">No jobs with current filter</p>
	<ng-container *ngFor="let key of keys">
		<details *ngIf="collection && collection.get && collection.get(key)">
			<summary>{{ collection.get(key).name }} ({{ collection.get(key).jobs.length }})</summary>
			<div class="job-container" *ngFor="let job of collection.get(key).jobs">
				<a mat-flat-button [href]="job.urlHash">
					<p class="job-name-container">
						<span>{{ job.jobName }}</span>
					</p>					
					<span *ngIf="job.siteName">{{ job.siteAddress }}</span>
					<span class="job-asset" *ngIf="job.asset">{{ job.asset }}</span>
					<span>Last Submitted On:
						{{ job.lastSavedDate ? moment.parseZone(job.lastSavedDate).format('dddd, MM/DD/YYYY') : 'N/A' }}
					</span>
				</a>
				<div class="job-container-actions">
					<mat-icon *ngIf="job.hasForms">description</mat-icon>

					<a [href]="job.urlHash + '/digital-log'"
						*ngIf="!!job.hasDigitalLogForms" mat-icon-button class="job-action">
						<mat-icon [svgIcon]="'multiple-documents'"></mat-icon>
					</a>
				</div>
			</div>
		</details>
	</ng-container>
</ng-template>

<ng-template #smartDocumentsList let-collection="collection" let-keys="keys">
	<p class="empty-message-container" *ngIf="!collectionHasValues(collection)">No jobs with current filter</p>
	<ng-container *ngFor="let key of keys">
		<details *ngIf="collection && collection.get && collection.get(key)">
			<summary>{{ collection.get(key).name }} ({{ collection.get(key).jobs.length }})</summary>

			<div class="job-container" *ngFor="let job of collection.get(key).jobs">
				<a mat-flat-button [href]="job.urlHash"
					[class.gray-text]="job.assignmentType !== null && job.assignmentType == AssignmentType.NotAssignedToYou">
					<p class="job-name-container">
						<span>{{ job.jobName }}</span>
						<mat-icon *ngIf="job.hasForms">description</mat-icon>
					</p>										
					<span *ngIf="job.siteAddress">{{ job.siteAddress }}</span>
					<span class="job-asset">{{ job.asset }}</span>
					<span *ngIf="job.assignmentType !== null">{{ assignmentTypeLabel(job.assignmentType) }}</span>
				</a>
			</div>
		</details>
	</ng-container>
</ng-template>

<generic-modal #filtersModal [onHide]="onHide">
	<ng-template #modalHeading>
		Apply filters
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">
			<form class="main-form" [formGroup]="filtersFormModel" (keyup.enter)="applyFilters(); filtersModal.hide();">

				<mat-form-field>
					<mat-label>Project</mat-label>
					<mat-select formControlName="pid">
						<mat-option [value]="null">None</mat-option>
						<mat-option *ngFor="let item of projectFilterModel" [value]="item.id">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field>
					<mat-label>Site</mat-label>
					<mat-select formControlName="sid">
						<mat-option [value]="null">None</mat-option>
						<mat-option *ngFor="let item of siteFilterModel" [value]="item.id">
							{{item.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<mat-form-field>
					<mat-label>Custom search</mat-label>
					<input matInput formControlName="sq" />
				</mat-form-field>
			</form>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="applyFilters(); filtersModal.hide();">Apply</button>
		<button mat-flat-button (click)="filtersModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>